import { render, staticRenderFns } from "./PromoScreen.vue?vue&type=template&id=5757ef4a&scoped=true&"
import script from "./PromoScreen.vue?vue&type=script&lang=js&"
export * from "./PromoScreen.vue?vue&type=script&lang=js&"
import style0 from "./PromoScreen.vue?vue&type=style&index=0&id=5757ef4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5757ef4a",
  null
  
)

export default component.exports